<paedml-modal-collect>
  <paedml-modal prefix={opts.prefix} heading={opts.heading} opname={opts.opname}
                selectedrowsfunc={opts.selectedrowsfunc} idcol="{opts.idcol || 0}" idtextcol="{opts.idtextcol || 1}"
                submitfunc={submitHandler} patient={patient}
                cancelbutton={true}
                >

    <yield to="fields">
      <div class="row">
        <div class="m-2 p-2">
          <span class="pl-1 pt-2">Die von den Schüler*innen bearbeiteten Dateien werden gezippt in den Ordner '<strong class="text-primary">_eingesammelt</strong>' auf Ihrem Laufwerk '<strong class="text-primary">H:\</strong>' abgelegt</span>
        </div>
      </div>

      <paedml-form-input if={parent.showDelete} name="deleteAfterwards" placeholder={parent.deleteText}
        fgclass="py-1" type="checkbox" revlut="jaNein" handleChange={parent.handleDeleteAfterwardsChanged} />

      <div if={parent.variant === 'exam' && parent.data.deleteAfterwards} class="mt-2 mr-1 p-2 border border-danger">
        <span><paedml-icon icon="fas-exclamation-triangle" simple="danger" />
          <strong class="text-danger pl-1 pt-2">Achtung mit dieser Aktion werden die Klassenarbeitsdaten der Schüler auf den betreffenden Klassenarbeits-Laufwerken gelöscht. Diese stehen also danach nicht mehr zur Verfügung. 
            <br/><br/>
            Achten Sie deshalb darauf die Heruntergeladenen Zip-Dateien sicher zu verwahren.  
          </strong>  
        </span>
      </div>
    </yield>
  </paedml-modal>

  <script>
    import * as R from 'ramda'
    import {toTrueMap} from '../util/mapping-util'
    import {patientFormatter} from '../util/modal-util'
    import API from '../api'
    
    this.prefix = opts.prefix
    this.data = {
    }
    this.api = this.opts.api
    this.patient = opts.patient
    this.variant = opts.variant
    this.showDelete = false
    this.op = opts.variant === 'exam' ? 'exam' : 'handout'
    this.deleteText = opts.variant === 'exam' ? "Nach dem Einsammeln die Daten bei den Klassenarbeitsteilnehmer*innen löschen" : 'Nach dem Einsammeln die Daten bei den Schüler*innen löschen und den Eintrag aus der Schulkonsole entfernen'
    
    this.data = {
      deleteAfterwards: false
    }

    this.on('dataRequested', (selectedRows) => {
        this.showDelete = this.opts.variant === 'handout' || selectedRows[0][6] === 'nein'
    })

    this.handleSuppressWarnings = val => {
       this.data.deleteAfterwards = val
     }

    this.submitHandler = formData => {
      if (formData.ids.length < 1) return Promise.resolve('Operation abgebrochen')

      return API[this.op].collect(formData.ids[0], this.data.deleteAfterwards).then(rsp => {
        const [data, status] = rsp
          if (status.success) {
            if (formData.deleteAfterwards) {
              this.parent.trigger('reloadTable')
              return `Dateien erfolgreich eingesammelt und gelöscht`
            }
            return `Dateien erfolgreich eingesammelt`
          }

          console.error('error-data', data)
          console.error('error-status', status)
          const reason = data && data.message ? data.message : 'unbekannt'
          return Promise.reject(`Einsammeln fehlgeschlagen. Grund: ${reason}`)
      })

    }

  </script>
</paedml-modal-collect>
